import React from 'react'
import { useNavigate } from 'react-router-dom';

export const ArrowIcon = ({link}) => {
          const navigate = useNavigate();
            const handleNavigation = () => {
        navigate(`${link}`);
        window.scrollTo(0, 0); // Navigue vers la page "About"
      };
  return (
        <div onClick={handleNavigation}>
<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
  <path d="M2.5 12.5H22.5M22.5 12.5L13.5 3.5M22.5 12.5L13.5 21.5" stroke="white" stroke-width="2"/>
</svg></div>
  )
}
